import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';


import { MatSnackBar } from "@angular/material/snack-bar";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { DATOS_API } from 'app/auth/auth.datos';
interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};
import { FormDialogComponent } from 'app/main/pagina/certificar/shedulesurvey/formdialog/form.component';

//SERVICE
import { SheduleService } from "../services/shedule.service";

///IDIOMAS
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector     : 'shedule-survey',
    templateUrl  : './shedule.component.html',
    styleUrls    : ['./shedule.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class SheduleComponent implements OnInit {
  idiomaActual:string;
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERRORDATE',
    'SHEDULE.SAMEDATE',
    'SHEDULE.ERR01',
    'SHEDULE.ERR02',
    'SHEDULE.ERR04',
    'SHEDULE.ERR05',
    'SHEDULE.ERR03',

  ];

  mensajesTraducirTS = {
    error1: '',
    error2: '',
    error3:'',
    error4:'',
    error5:'',
    error6:'',
  };

  flagButton : number = 0;
  flagEncuesta : number = 0;
  flagUsuarios : number = 0;
  flagSeccion1 : number = 0;
  flagSeccion2 : number = 0;
  flagSeccion3 : number = 0;
  flagSeccion4 : number = 0;
  flagSeccion5 : number = 0;
  flagSeccion6 : number = 0;
  flagSeccion7 : number = 0;

  flagShowSeccion1 : boolean = false;
  flagShowSeccion2 : boolean = false;
  flagShowSeccion3 : boolean = false;
  flagShowSeccion4 : boolean = false;
  flagShowSeccion5 : boolean = false;
  flagShowSeccion6 : boolean = false;
  flagShowSeccion7 : boolean = false;

  fechaLanzamiento: any;
  fechaCierre: any;
  centered = false;
  disabled = false;
  unbounded = false;
  showButtonInstitute: boolean = true;
  show: boolean = true;
  showCierre: boolean = true;

  idLanzamiento: string = "";

  labelDate: string = '';
  labelCierre: string = '';
  labelRecordatorio: string = '';
  EstatusEncuesta:boolean=false;

  radius: number;
  color: string;

  dialogRef: any;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  //boolean paso completo
  pasoCompleto = false;
  arrayRecordatorios: any;

  filtroFechas:any;
  fechaLanzamientoOK: boolean=false;

  constructor(
    public dialog: MatDialog,
    private service : SheduleService,
    private programacionService: ProgramacionService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public snackBar: MatSnackBar,
    private wizardService: WizardService,
    private translateSrv: TranslateService,
    private dateAdapter: DateAdapter<Date>){

    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });



    lang_shedule.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.getFechaLanzamiento();

    this.getestatusSecciones();
    this.getEstatusEncuestaNew();
    //this.compareFlags();

    if(localStorage.getItem('instituto') == '1'){
      this.showButtonInstitute = false;
    }else{
      this.showButtonInstitute = true;
    }



  }
  ngOnInit() {
    this.obtieneCertificarActual();
    this.traduceTextosTS();

    this.getEstatusEncuesta();

  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente

    this.programacionService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.programacionService.getStatusProgramacion(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;
      });

      this.getStatusModal();
      //obtiene las preguntas adicionales guardadas
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      productoId: localStorage.getItem('productoID'),
      programacion: 1
    };
    //console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('PROGRAMACION');
      }
    });
  }

  updateStatusModal(){
    let datos={
      productoId: this.productoCertificar.idCertificar,
      programacion: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  completarPaso(){
    console.log(this.flagButton);
    if(this.pasoCompleto){
      this.aletaRestric('PROGRAMACION.COMPLETADO',null,'warning');
    }else{
      // this.checkFlags();
      if(this.flagButton == 1 && this.labelDate.length> 0){
        this.aletaRestric('PROGRAMACION.COMPLETAR',true);
        console.log("uno");
      }
      else{
        if(this.flagSeccion7 == 2){
          this.aletaRestric('PROGRAMACION.COMPLETAR',true);
          console.log("tres");
        }
        else{
          if(this.labelDate.length == 0){
            this.aletaRestric('PROGRAMACION.FECHALANZAMIENTO',null,'warning');
            console.log("Falta fecha lanzamiento");
          }
          else{
          Swal.fire(this.translateSrv.instant('SHEDULE.LAUNCH_SURVEY'));
          console.log("cuatro");
          }
        }

      }

      /*
      let data = {
        fechaCertificar: localStorage.getItem('fechaProducto')
      }
      this.service.getEstatusEncuesta(data)
        .subscribe(response => {
          //console.log(response);
          if(response['success'] == true){


            let res = this.validateFlags(response);

            if(res>0){
              Swal.fire(this.translateSrv.instant('SHEDULE.LAUNCH_SURVEY'));
            }else{
              this.aletaRestric('PROGRAMACION.COMPLETAR',true);
            }
          }

      }, error => {
        console.log(error);
      });*/

      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }
  // aletaRestric(mensaje:string,confirmar?:boolean){
  //
  //     let infoModal: adverModal = {'tipo': 3, 'confirma': confirmar, 'mensaje': mensaje, 'diccionario': 'WIZARD.CERTIFICAR.'};
  //     const confirmaMod = this.dialog.open(ModalComponent, { data:infoModal });
  //
  //     if(confirmar){
  //       confirmaMod.afterClosed().subscribe(resultado => {
  //         if(resultado){
  //           this.programacionService.guardaStatusProgramacion(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.RespuestaGen) => {
  //             if(data.message == '215'){
  //               this.aletaRestric('PROGRAMACION.'+data.message);
  //               this.pasoCompleto = true;
  //               this.enviaOrdenWizard();
  //             };
  //           });
  //         }
  //       });
  //     }
  // }
  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
/*
          let data = {
            fechaCertificar: localStorage.getItem('fechaProducto')
          };
          console.log(data);
          Swal.fire({
               title: this.translateSrv.instant('SHEDULE.ESPERA_ENCUESTA'),
               allowOutsideClick: false
            });

          Swal.showLoading()
          this.service.sendSurvey(data)
            .subscribe(response => {
                console.log(response);
                if(response['message'] == 'Success'){
                  Swal.close();
*/
                  this.programacionService.guardaStatusProgramacion(this.productoCertificar.idCertificar).subscribe( (data: backInter.RespuestaGen) => {
                    if(data.message == '215'){
                      this.aletaRestric('PROGRAMACION.'+data.message,null,'success');
                      this.pasoCompleto = true;
                      this.enviaOrdenWizard();
                    };
                  });
                  /*
                }

              }, error => {
                //console.log(error);
              });*/


        }
      });
    }
    else{
      let tipoMsg: any = tipo;
      Swal.fire({
        title: texto,
        icon: tipoMsg,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }

  }
    flafAdvice:any;
    auxDate:any;
    addDate(aux: number): void
    {
        this.traduceTextosTS();
        if(this.idiomaActual=='zh1' || this.idiomaActual=='zh2'){
          this.dateAdapter.setLocale('zh');
        }else{
          this.dateAdapter.setLocale(''+this.idiomaActual+'');
        }

        this.dialogRef = this.dialog.open(FormDialogComponent, {
          data: {filtroFechas:this.filtroFechas}
        });

        this.dialogRef.afterClosed()
            .subscribe(result => {
              console.log(result);

            this.auxDate= new Date(result);
            var date = new Date(result),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            //  Ahora a obtener la fecha actual
            var now = new Date();
            var date2 = new Date(now),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
              // Fin obtener fecha actual

              // transformación
            var moment = require('moment');
            var newnow = moment(now).format('MM/DD/YYYY');
            var newresult = moment(result).format('MM/DD/YYYY');
            // Fin transformación
            this.flafAdvice=this.diferenciaEntreDiasEnDias(newresult,newnow);

            if(this.flafAdvice==true){
              //console.log(date.getDate());
              //console.log(result);

            if(result != 'close'){
              if(result != null){
                if(aux == 1){
                  console.log(localStorage.getItem('instituto'));

                  if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
                    if(moment(result).format('MM/DD/YYYY') != moment().format('MM/DD/YYYY')){
                      this.labelDate = date.getFullYear()+' - '+mnth+' - '+day;
                      this.registerDate(date.getFullYear()+'-'+mnth+'-'+day);
                    }
                    else{
                      Swal.fire({
                        title: this.mensajesTraducirTS.error2,
                        icon: 'warning',
                        confirmButtonColor: '#e40601'
                      });
                    }
                  }
                  else{
                    this.labelDate = date.getFullYear()+' - '+mnth+' - '+day;
                    this.registerDate(date.getFullYear()+'-'+mnth+'-'+day);
                  }
                }else if(aux == 2){
                  this.labelCierre = date.getFullYear()+' - '+mnth+' - '+day;
                  this.registerClose(date.getFullYear()+'-'+mnth+'-'+day,date);


                }else{
                  var date2 = new Date(now),
                  mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
                  day = ("0" + date2.getDate()).slice(-2);
                  var timestamp1 = new Date(this.auxDate).getTime();
                  var timestamp2 = new Date(this.fechaCierre).getTime();
                  var timestamp3 = new Date(this.fechaLanzamiento).getTime();
                  var timestamp4 = new Date(date2).getTime();
                  if(moment(result).format('MM/DD/YYYY') == moment().format('MM/DD/YYYY')){
                    Swal.fire({
                      title: this.mensajesTraducirTS.error2,
                      icon: 'warning',
                      confirmButtonColor: '#e40601'
                    });
                  }else if(timestamp1<timestamp4){
                    console.log("Entro");
                    console.log(timestamp1);
                    console.log(timestamp4);
                    let texto = 'SHEDULE.ERR05';
                    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                        Swal.fire(
                        ''+texto,
                        '',
                        'error',
                      );

                  }else{
                    if(timestamp1>timestamp3){
                      if(timestamp1 < timestamp2){

                        this.filtroFechas = (d: Date | null): boolean => {
                          let day:any = (d || new Date()).getDate();
                          let mes:any = (d || new Date()).getMonth();
                          let anio:any = (d || new Date()).getFullYear();

                          if(day < 10)
                            day = "0"+day;
                          if(mes < 10)
                            mes = "0"+(mes+1);

                          // return day !== 0 && day !== 6;
                          // console.log(anio + "-" + mes + "-" + day);

                          return !this.labelRecordatorio.includes(anio + "-" + mes + "-" + day);
                        }

                        //this.labelRecordatorio = date.getFullYear()+' - '+mnth+' - '+day;
                         this.registerRecordatorio(date,date);
                      }else{

                        let texto = 'SHEDULE.ERR03';
                        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                        this.traduceTextosTS();
                        Swal.fire(
                        ''+texto,
                        '',
                        'error',
                        );
                      }
                    }else{
                      let texto = 'SHEDULE.ERR03';
                      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                        Swal.fire(
                          ''+texto,
                          '',
                          'error'
                        );
                    }

                  }


                }
              }else{
                console.log("Here dude");
                this.labelRecordatorio = '';
                this.openErrorSnackBar(this.translateSrv.instant('SHEDULE.SELECCIONE_FECHA'),this.translateSrv.instant('ALERTS.OK'));
              }
            }


            }else{
             // this.mensajesTraducirTS[k];
             //console.log(this.mensajesTraducirTS.error1);
              let tipoMsg: any = "error";
              Swal.fire({
                title: ""+this.mensajesTraducirTS.error1,
                icon: tipoMsg,
                confirmButtonColor: '#e40601'
              });
            }
          });
    }

    private registerDate(fecha){
      const moment = require('moment');
      let data={
          'fechaCertificar' : localStorage.getItem('fechaProducto'),
          'fechaLanzamiento' : fecha
      };
      console.log("Data a registrar");
      console.log(data);

      //this.translateSrv.instant('SHEDULE.LESSDAYS_T');
      let hoy = moment();
      let fechaElegida = moment(fecha);
      // if(moment(fecha).format('MM/DD/YYYY') != moment().format('MM/DD/YYYY')){
      // }
      console.log("diferencia de dias");
      console.log(fechaElegida.diff(hoy,'days'));

      if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
        if(fechaElegida.diff(hoy,'days') < 15){
          Swal.fire({
            title: this.translateSrv.instant('SHEDULE.LESSDAYS_T'),
            text: this.translateSrv.instant('SHEDULE.LESSDAYS_I'),
            icon: 'warning',
            showCancelButton: true,
reverseButtons: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
            cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
          }).then((result) => {
            if (result.value) {
              Swal.fire({
                title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
                text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
                icon: 'warning',
                showCancelButton: true,
reverseButtons: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
                cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
              }).then((result) => {
                if (result.value) {
                  this.guardaFechaLanzamiento(data);
                }
              });
            }
          });
        }
        else{
          Swal.fire({
            title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
            text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
            icon: 'warning',
            showCancelButton: true,
reverseButtons: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
            cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
          }).then((result) => {
            if (result.value) {
              this.guardaFechaLanzamiento(data);
            }
          });
        }
      }
      else{
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
          text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.guardaFechaLanzamiento(data);
          }
        });
      }



  }
  guardaFechaLanzamiento(data:any){
    this.service.registerDate(data).subscribe(response => {
      //console.log(response);
      if(response['message'] == '221'){

        this.openSuccessSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        //console.log(response);
        this.idLanzamiento = response['programacion']['_id'];
        this.fechaLanzamiento = response['programacion']['fechaLanzamiento'];
        this.show = false;
        this.fechaLanzamientoOK=true;

      }

    }, error => {
      //console.log(error);
    });

  }

  private registerClose(fecha,fechaData){

     if(this.idLanzamiento.length > 0){
       if(fechaData > new Date(this.fechaLanzamiento)){
         let data={
               'fechaCertificar' : localStorage.getItem('fechaProducto'),
               'idProgramacion' : this.idLanzamiento,
               'fechaCierre' : fecha

           };

           this.service.registerCierre(data)
             .subscribe(response => {

               //console.log(response);
                if(response['message'] == '220'){

                   this.openSuccessSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
                   this.fechaCierre = fechaData;
                   this.showCierre = false;
                 }

               }, error => {
                 //console.log(error);
               });
       }else{
         this.labelCierre = '';
         this.openErrorSnackBar(this.translateSrv.instant('SHEDULE.CLOSE_MSJ1'),this.translateSrv.instant('ALERTS.OK'));
       }

     }else{
       this.labelCierre = '';
       this.openErrorSnackBar(this.translateSrv.instant('SHEDULE.CLOSE_MSJ2'),this.translateSrv.instant('ALERTS.OK'));
     }
   }

 private registerRecordatorio(fecha,fechaData){
  // console.log(this.fechaLanzamiento);

    if(this.idLanzamiento.length > 0){
      this.getRecordatorios();
      //if(this.fechaCierre.length > 0){
          if(fechaData > new Date(this.fechaLanzamiento)){
              let data={
                    'fechaCertificar' : localStorage.getItem('fechaProducto'),
                    'idProgramacion' : this.idLanzamiento,
                    'fechaRecordatorio' : fecha
                };
                // console.log(data);
                this.service.registerRecordatorio(data)
                  .subscribe(response => {

                      //console.log(response);
                      if(response['message'] == '220'){

                        this.openSuccessSnackBar(this.translateSrv.instant('SHEDULE.REMIDEROK'),this.translateSrv.instant('ALERTS.OK'));
                        this.getRecordatorios();
                      }

                    }, error => {
                      //console.log(error);
                    });
            }else{
              this.labelRecordatorio = '';
              this.openErrorSnackBar(this.translateSrv.instant('SHEDULE.REMIDER_MSJ1'),this.translateSrv.instant('ALERTS.OK'));
            }
        /*}else{
          this.labelRecordatorio = '';
          this.openErrorSnackBar('Before registering a reminder you must register the close date','OK');
        }*/
    }else{
      this.labelRecordatorio = '';
      this.openErrorSnackBar(this.translateSrv.instant('SHEDULE.REMIDER_MSJ2'),this.translateSrv.instant('ALERTS.OK'));
    }
  }

   getFechaLanzamiento(){
      let data={
            'productoId' : localStorage.getItem('productoID')
        };

        this.service.getFechaLanzamiento(data)
          .subscribe(response => {
            console.log(response);

            let x = response['fechaLanzamiento'];

            let y = response['fechaCierre'];

            if(response['message'] == '200'){

              this.idLanzamiento = response['idFechaLanzamiento'];
              this.labelDate = response['fechaLanzamiento'];
              this.fechaLanzamiento = response['fechaLanzamiento'];
              this.fechaLanzamientoOK=true;

              let aux: string = '';
              if(response.hasOwnProperty('fechaCierre')){
                this.labelCierre = response['fechaCierre'];
                this.fechaCierre = response['fechaCierre']
                console

                var dateCierre = new Date(this.labelCierre);
                this.labelCierre = dateCierre.getFullYear()+' - '+dateCierre.getMonth()+' - '+(dateCierre.getDate()+1);

                this.showCierre = false;

              }


              this.show = false;

              var d = new Date(this.labelDate.replace(/-/g, '\/').replace(/T.+/, ''));
              console.log(this.labelDate);
              console.log(d);

              //  2019 - 8 - 12
              let tmp=d.getMonth()+1;

              this.labelDate = d.getFullYear()+' - '+tmp+' - '+(d.getDate());


              this.getRecordatorios();
            }

        }, error => {
          //console.log(error);
        });

  }
 fechaEjemplo:any;
 //arrayRecordatorios_second:any;
 arrayRecordatorios_second: Array<any> = [];
 statusRecordatorios:boolean=false;
  private getRecordatorios(){

      let data={
            'productoId' : localStorage.getItem('productoID')
        };

        this.service.getRecordatorios(data)
          .subscribe(response => {
            //console.log("Response");
            //console.log(response);
            if(response['message'] == '200'){
              this.arrayRecordatorios = response['recordatoriosMostrar'];
              this.leerArrayRecordatorio(this.arrayRecordatorios);
              if(this.arrayRecordatorios.length >= 3){
                this.statusRecordatorios=true;
              }
            }

        }, error => {
          //console.log(error);
        });

  }

  TotalDias:any;
  diferenciaEntreDiasEnDias(a, b)
  {

    const moment = require('moment');
    var timestamp1 = new Date(a).getTime();
    var timestamp2 = new Date(b).getTime();
    var diff =  timestamp1 - timestamp2 ;
    this.TotalDias =  Math.round(diff/86400000);

    if(this.TotalDias<0){
      return false;
    }else{
      return true;
    }
  }


  leerArrayRecordatorio(array){
    let fechaAux:string;
    var auxTmp=array.length;
    var cont=0;
    for(let i=0; i<array.length;i++){
        fechaAux=array[i].fechaRecordatorio;
      // console.log(fechaAux.substr(0,10));
     array[i].fechaRecordatorio=fechaAux.substr(4,15);
     this.arrayRecordatorios_second[i]=fechaAux.substr(0,10);
     console.log(this.arrayRecordatorios_second);
     cont=i;



     //this.arrayRecordatorios_second[i]=fechaAux;
     //console.log(this.arrayRecordatorios_second[i]);


    }
    this.labelRecordatorio=this.arrayRecordatorios_second[cont];

    cont=0;
    this.filtroFechas = (d: Date | null): boolean => {
      let day:any = (d || new Date()).getDate();
      let mes:any = (d || new Date()).getMonth();
      let anio:any = (d || new Date()).getFullYear();

      if(day < 10)
        day = "0"+day;
      if(mes < 10)
        mes = "0"+(mes+1);

      // return day !== 0 && day !== 6;
      // console.log(anio + "-" + mes + "-" + day);

      return !this.arrayRecordatorios_second.includes(anio + "-" + mes + "-" + day);
    }
  }

  openErrorSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 7000,
         verticalPosition: 'top',
         panelClass: ['background-red']
      });
   }


   openSuccessSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
         duration: 7000,
         verticalPosition: 'top',
         panelClass: ['background-success']
      });
   }
   // Traducciones
   traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        //console.log(k);
        this.mensajesTraducirTS[k] = res;
        // console.log(this.mensajesTraducirTS[k]);
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;


  }
  obtenerIdioma(numError){
    this.idiomaActual = this.translateSrv.currentLang;


    this.getTypeError(numError);
  }
  getTypeError(numError){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        if(k == numError){
          //console.log("Respuesta para sweet ");
          this.mensajesTraducirTS[k] = res;
          //console.log(this.mensajesTraducirTS[k]);
          this.mensajeSwal(this.mensajesTraducirTS[k],3);
        }
        //this.mensajesTraducirTS[k] = res;
        //console.log(this.mensajesTraducirTS[k]);
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
    //console.log(this.idiomaActual);
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }







  velidateBanderas(){

    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.service.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {

        console.log(respuesta);
        if(respuesta.success){
          if(respuesta.logo){
            if(respuesta.requerimientos){
              this.createEncuesta();
            }
            else{
              Swal.fire({
                icon: 'error',
                title: this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'),
                
                confirmButtonText: "OK"
              });
            }
          }
          else{
            Swal.fire({
              icon: 'error',
              title: this.translateSrv.instant('SHEDULE.SUBIRLOGO'),
              
              confirmButtonText: "OK"
            });
          }
        }

    }, error => {
      console.log(error);
    });

  }
  bloquearEncuesta:boolean=false;
  createEncuesta(){
    if(!this.bloquearEncuesta){
      this.bloquearEncuesta=true;
      this.flagButton = 1;
    this.flagUsuarios = 0;
    this.flagSeccion1 = 0;
    this.flagSeccion2 = 0;
    this.flagSeccion3 = 0;
    this.flagSeccion4 = 0;
    this.flagSeccion5 = 0;
    this.flagSeccion6 = 0;
    this.flagSeccion7 = 0;
    //console.log('init createEncuesta');
    this.flagEncuesta = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.crearEncuesta(data)
      .subscribe(response => {
        console.log('ENCUESTA');
        console.log(response);
        if(response['success'] == true){
          this.flagEncuesta = 2;
          this.sendUsers();
        }else{
          this.flagEncuesta = 3;
        }

    }, error => {
      this.flagEncuesta = 3;
      console.log(error);
    });
    }


  }

  sendUsers(){
    console.log('init sendUsers');
    this.flagUsuarios = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveUsuarios(data)
      .subscribe(response => {
        console.log('saveUsuarios');
        console.log(response);
        if(response['success'] == true){
          this.flagUsuarios = 2;
          if(this.flagShowSeccion1){
              this.sendSenction1();
          }else if(this.flagShowSeccion2){
            this.sendSenction2();
          }else if(this.flagShowSeccion3){
            this.sendSenction3();
          }else if(this.flagShowSeccion4){
            this.sendSenction4();
          }else if(this.flagShowSeccion5){
            this.sendSenction5();
          }else if(this.flagShowSeccion6){
            this.sendSenction6();
          }else if(this.flagShowSeccion7){
            this.sendSenction7();
          }

        }else{
          this.flagUsuarios = 3;
        }

    }, error => {
      this.flagUsuarios = 3;
      console.log(error);
    });
  }
  /*
  applyUsers(){
    console.log('init applyUsers');
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.applyUsuarios(data)
      .subscribe(response => {
        console.log('applyUsuarios');
        console.log(response);
        if(response['success'] == true){
          this.flagUsuarios = 2;
          this.sendSenction1();
        }else{
          this.flagUsuarios = 3;
        }

    }, error => {
      this.flagUsuarios = 3;
      console.log(error);
    });
  }
*/
  sendSenction1(){
    console.log('init NPS');
    this.flagSeccion1 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveNPS(data)
      .subscribe(response => {
        console.log('saveNPS');
        console.log(response);
        if(response['success'] == true){
          this.flagSeccion1 = 2;
          if(this.flagShowSeccion2){
            this.sendSenction2();
          }else if(this.flagShowSeccion3){
            this.sendSenction3();
          }else if(this.flagShowSeccion4){
            this.sendSenction4();
          }else if(this.flagShowSeccion5){
            this.sendSenction5();
          }else if(this.flagShowSeccion6){
            this.sendSenction6();
          }else if(this.flagShowSeccion7){
            this.sendSenction7();
          }
        }else{
          this.flagSeccion1 = 3;
        }

    }, error => {
      this.flagSeccion1 = 3;
      console.log(error);
    });
  }

  sendSenction2(){
    console.log('init REACTIVOS');
    this.flagSeccion2 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveReactivos(data)
      .subscribe(response => {
        console.log('saveReactivos');
        console.log(response);
        if(response['success'] == true){
          this.flagSeccion2 = 2;
          if(this.flagShowSeccion3){
            this.sendSenction3();
          }else if(this.flagShowSeccion4){
            this.sendSenction4();
          }else if(this.flagShowSeccion5){
            this.sendSenction5();
          }else if(this.flagShowSeccion6){
            this.sendSenction6();
          }else if(this.flagShowSeccion7){
            this.sendSenction7();
          }
        }else{
          this.flagSeccion2 = 3;
        }

    }, error => {
      this.flagSeccion2 = 3;
      console.log(error);
    });
  }
  sendSenction3(){
    //console.log('init CONTROL');
    this.flagSeccion3 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveControl(data)
      .subscribe(response => {
        //console.log('saveControl');
        ///console.log(response);
        if(response['success'] == true){
          this.flagSeccion3 = 2;
          if(this.flagShowSeccion4){
            this.sendSenction4();
          }else if(this.flagShowSeccion5){
            this.sendSenction5();
          }else if(this.flagShowSeccion6){
            this.sendSenction6();
          }else if(this.flagShowSeccion7){
            this.sendSenction7();
          }
        }else{
          this.flagSeccion3 = 3;
        }

    }, error => {
      this.flagSeccion3 = 3;
      console.log(error);
    });
  }
  sendSenction4(){
    //console.log('init DEMOGRAFICOS');
    this.flagSeccion4 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveDemograficos(data)
      .subscribe(response => {
        //console.log('saveDemograficos');
        //console.log(response);
        if(response['success'] == true){
          this.flagSeccion4 = 2;
          if(this.flagShowSeccion5){
            this.sendSenction5();
          }else if(this.flagShowSeccion6){
            this.sendSenction6();
          }else if(this.flagShowSeccion7){
            this.sendSenction7();
          }
        }else{
          this.flagSeccion4 = 3;
        }

    }, error => {
      this.flagSeccion4 = 3;
      console.log(error);
    });
  }
  sendSenction5(){
    //console.log('init ADICIONALES');
    this.flagSeccion5 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveAdicionales(data)
      .subscribe(response => {
        //console.log('saveAdicionales');
        //console.log(response);
        if(response['success'] == true){
          this.flagSeccion5 = 2;
          if(this.flagShowSeccion6){
            this.sendSenction6();
          }else if(this.flagShowSeccion7){
            this.sendSenction7();
          }
        }else{
          this.flagSeccion5 = 3;
        }

    }, error => {
      this.flagSeccion5 = 3;
      console.log(error);
    });
  }
  sendSenction6(){
    //console.log('init FORALL');
    this.flagSeccion6 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveForall(data)
      .subscribe(response => {
        //console.log('saveForall');
        //console.log(response);
        if(response['success'] == true){
          this.flagSeccion6 = 2;
          if(this.flagShowSeccion7){
            this.sendSenction7();
          }

        }else{
          this.flagSeccion6 = 3;
        }

    }, error => {
      this.flagSeccion6 = 3;
      console.log(error);
    });
  }

  sendSenction7(){
    console.log('sendSenction7 Abiertas');
    this.flagSeccion7 = 1;
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
    this.service.saveAbiertas(data)
      .subscribe(response => {
        console.log('sendSenction7 Abiertas');
        console.log(response);
        if(response['success'] == true){
          this.flagSeccion7 = 2;
          this.bloquearEncuesta=false;
          Swal.fire(this.translateSrv.instant('SHEDULE.CONTINUE_FINISH'));
        }else{
          this.flagSeccion7 = 3;
        }

    }, error => {
      this.flagSeccion7 = 3;
      console.log(error);
    });
  }


  getEstatusEncuesta(){

    let data = {
      productoId: localStorage.getItem('productoID')
    }
    // this.service.getEstatusEncuesta(data).subscribe(response => {
    this.service.getEstatusEncuesta(data).subscribe((respuesta: backInter.getEstatusEncuesta) => {
      // console.log(respuesta);

      if(respuesta.success){
        if(respuesta.survey){
          this.flagButton = 1;
          this.flagEncuesta = 2;
          this.flagUsuarios = 2;
          this.flagSeccion1 = 2;
          this.flagSeccion2 = 2;
          this.flagSeccion3 = 2;
          this.flagSeccion4 = 2;
          this.flagSeccion5 = 2;
          this.flagSeccion6 = 2;
          this.flagSeccion7 = 2;
        }
        else{
          this.flagButton = 0;
        }
      }
        // console.log(response);
        // if(response['success'] == true){
        //   let res = this.validateFlags(response);
        //   if(res>0){
        //     this.flagButton = 0;
        //   }else{
        //     this.flagButton = 1;
        //     this.flagEncuesta = 2;
        //     this.flagUsuarios = 2;
        //     this.flagSeccion1 = 2;
        //     this.flagSeccion2 = 2;
        //     this.flagSeccion3 = 2;
        //     this.flagSeccion4 = 2;
        //     this.flagSeccion5 = 2;
        //     this.flagSeccion6 = 2;
        //     this.flagSeccion7 = 2;
        //   }
        // }
    }, error => {
      console.log(error);
    });
  }



  validateFlags(response){
    let contador = 0;
    if(response['adicionales'] == false){
      contador++;
    }
    if(response['abiertas'] == false){
      contador++;
    }
    if(response['control'] == false){
      contador++;
    }
    if(response['demograficos'] == false){
      contador++;
    }
    if(response['forall'] == false){
      contador++;
    }
    if(response['nps'] == false){
      contador++;
    }
    if(response['reactivos'] == false){
      contador++;
    }
    if(response['success'] == false){
      contador++;
    }
    if(response['survey'] == false){
      contador++;
    }
    if(response['users'] == false){
      contador++;
    }
    if(response['usersApply'] == false){
      contador++;
    }

    return contador;
  }

  getestatusSecciones(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.service.getStatusSecciones(data)
      .subscribe(response => {
        //console.log('SECCIONES');
        //console.log(response);
        this.compareFlags(response);
        for (let i = 0; i < response['secciones'].length; i++) {



          switch (response['secciones'][i]['nombre']) {
            case "Reactivos":
              this.flagShowSeccion2 = response['secciones'][i]['estatus'];
              break;
            case "NPS":
              this.flagShowSeccion1 = response['secciones'][i]['estatus'];
              break;
            case "Demograficos":
              this.flagShowSeccion4 = response['secciones'][i]['estatus'];
              break;
            case "Forall":
              this.flagShowSeccion6 = response['secciones'][i]['estatus'];
              break;
            case "Adicionales":
              this.flagShowSeccion5 = response['secciones'][i]['estatus'];
              break;
            case "Control":
              this.flagShowSeccion3 = response['secciones'][i]['estatus'];
              break;
            case "Abiertas":
              this.flagShowSeccion7 = response['secciones'][i]['estatus'];
              break;

            default:
              break;
          }
        }

        /*
        if(response['success'] == true){
          this.flagSeccion1 = 2;
          this.sendSenction2();
        }else{
          this.flagSeccion1 = 3;
        }*/

    }, error => {
      console.log(error);
    });
  }

  checkFlags(){
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.service.getStatusSecciones(data)
      .subscribe(response => {


        if(this.compareFlags(response)){
          this.aletaRestric('PROGRAMACION.COMPLETAR',true);
        }else{
          Swal.fire(this.translateSrv.instant('SHEDULE.LAUNCH_SURVEY'));
        }

    }, error => {
      console.log(error);
    });

  }

  compareFlags(response): any{
    let data = {
      productoId: localStorage.getItem('productoID')
    }
    this.service.getEstatusEncuesta(data)
      .subscribe(result => {

        // console.log(result);

        let aux = true;
        for (let i = 0; i < response['secciones'].length; i++) {
          switch (response['secciones'][i]['nombre']) {
            case "Reactivos":
            //response['secciones'][i]['estatus']
              if(result['reactivos'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;
            case "NPS":
              if(result['nps'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;
            case "Demograficos":
              if(result['demograficos'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;
            case "Forall":
              if(result['forall'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;
            case "Adicionales":
              if(result['adicionales'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;
            case "Control":
              if(result['control'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;
            case "Abiertas":
              if(result['abiertas'] != response['secciones'][i]['estatus']){
                aux = false;
              }
              break;

            default:
              break;
          }
        }
        // console.log('RESPUESTA DE VALIDACIÓN : '+aux);
        if(aux){
          this.flagButton = 2;
        }
        return aux;

    }, error => {
      console.log(error);
    });
  }


  urlEncuestadorNew(){
    console.log(localStorage.getItem('companyID'));

    let datos=DATOS_API.urlEncuestador+localStorage.getItem('productoID')+'&emp='+localStorage.getItem('companyID');
    console.log(datos);

    let data={productoId:localStorage.getItem('productoID'),linkEncuesta: datos}
    this.service.guardaLinkEncuesta(data).subscribe(response => {
      console.log(response);
      let texto = 'SHEDULE.CONTINUE_FINISH';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      let rspSi = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.OK';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      Swal.fire({
        title: texto,
        icon: "success",
        
        confirmButtonText: rspSi,

      });
      this.getEstatusEncuestaNew();

    }, error => {
      console.log(error);
    });

  }

  getEstatusEncuestaNew(){

    let data={productoId:localStorage.getItem('productoID')}
    this.service.getEncuestaEstatus(data).subscribe((response: any) => {
      console.log(response);

      if(response.linkGenerado==false){
        this.EstatusEncuesta=false;
      }else{
        this.EstatusEncuesta=true;
      }

      console.log(response)

    }, error => {
      console.log(error);
    });

  }


  velidateBanderasNew(){
 // if (this.fechaLanzamientoOK) {


    let datos = {
      productoId: localStorage.getItem('productoID')
    };
    this.service.getBanderas(datos).subscribe((respuesta:backInter.statusReqTec) => {
        //
        // console.log(respuesta);
        // if(respuesta.success){
        //   if(respuesta.logo){
        //     if(respuesta.requerimientos){
               this.urlEncuestadorNew();
        //     }
        //     else{
        //       Swal.fire({
        //         icon: 'error',
        //         title: this.translateSrv.instant('SHEDULE.ACEPTARREQUERIMIENTOS'),
        //         
        //         confirmButtonText: "OK"
        //       });
        //     }
        //   }
        //   else{
        //     Swal.fire({
        //       icon: 'error',
        //       title: this.translateSrv.instant('SHEDULE.SUBIRLOGO'),
        //       
        //       confirmButtonText: "OK"
        //     });
        //   }
        // }

    }, error => {
      console.log(error);
    });
// }else{
//   let rspSi = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.OK';
//   this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
//   let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.PROGRAMACION.NADA';
//   this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
//   Swal.fire({
//     title: texto,
//     icon: 'warning',
//     
//     confirmButtonText: rspSi,
//   });
// }
  }

}
